import React from 'react';
import {
  messageAreaMaxCount,
  messageEditorMaxCount,
} from '../../constants/common';
import { useSelector } from 'react-redux';
import {
  editorStateSelector,
  messageAreaStateSelector,
} from '../../store/selectors';
import styles from './PostMessageForm.module.scss';

const TextCounter = () => {
  const text = useSelector(messageAreaStateSelector);

  return (
    <p className={styles.letterCount}>
      {text?.length || 0}/{messageAreaMaxCount}
    </p>
  );
};

const EditorCounter = () => {
  const editorState = useSelector(editorStateSelector);
  const count = editorState.getCurrentContent().getPlainText().length;

  return (
    <p className={styles.editorCount}>
      {count}/{messageEditorMaxCount}
    </p>
  );
};

const Counter = ({ isHtml }) => {
  return isHtml ? <EditorCounter /> : <TextCounter />;
};

export default Counter;
